import { CSI_DASHBOARD_PATH } from 'csiDashboard'
import { HOME_PATH } from 'docReviewDashboard/Home'

import { Permissions } from 'core/application/account/permissions'

import { ROUTE_PATHS } from 'common/routePaths'

const { ICHRA_DECISION_TOOL_PATH, PROSPECTS_PATH } = ROUTE_PATHS

const DASHBOARD_PATH = '/admin-dashboard'
const ADMIN_SIGNUP_PATH = 'signup-flow'
const EMPLOYEE_SIGNUP_FLOW_PATH = '/ee-signup-flow'
const ELIGIBLE_EMPLOYEE_DASHBOARD_PATH = '/eligible-employee-dashboard'
const NON_ELIGIBLE_EMPLOYEE_SIGNUP_FLOW_PATH = '/non-ee-signup-flow'
const NON_ELIGIBLE_EMPLOYEE_DASHBOARD_PATH = '/non-eligible-employee-dashboard'

export const Routes = {
  adminDashboard: DASHBOARD_PATH,
  adminSignupWizard: ADMIN_SIGNUP_PATH,
  eligibleEmployeeSignupWizard: EMPLOYEE_SIGNUP_FLOW_PATH,
  eligibleEmployeeDashboard: ELIGIBLE_EMPLOYEE_DASHBOARD_PATH,
  nonEligibleEmployeeSignupWizard: NON_ELIGIBLE_EMPLOYEE_SIGNUP_FLOW_PATH,
  nonEligibleEmployeeDashboard: NON_ELIGIBLE_EMPLOYEE_DASHBOARD_PATH,
  docReviewDashbaord: `${ROUTE_PATHS.DOC_REVIEW_DASHBOARD_PATH}/${HOME_PATH}`,
  csiDashboardPath: `${CSI_DASHBOARD_PATH}/csi-search`,
  ichraDecisionToolPath: `${ICHRA_DECISION_TOOL_PATH}/${PROSPECTS_PATH}`,
}

export const RoutePermissionsMapping = new Map<Permissions, string>([
  [Permissions.AccessAdminDashboard, Routes.adminDashboard],
  [Permissions.AccessAdminSignUpWizard, Routes.adminSignupWizard],
  [Permissions.AccessEligibleEmployeeSignupWizard, Routes.eligibleEmployeeSignupWizard],
  [Permissions.AccessEligibleEmployeeDashboard, Routes.eligibleEmployeeDashboard],
  [Permissions.AccessNonEligibleEmployeeSignupWizard, Routes.nonEligibleEmployeeSignupWizard],
  [Permissions.AccessNonEligibleEmployeeDashboard, Routes.nonEligibleEmployeeDashboard],
  [Permissions.AccessDocReviewDashboard, Routes.docReviewDashbaord],
  [Permissions.AccessCsiDashboard, Routes.csiDashboardPath],
  [Permissions.AccessIchraDecisionTools, Routes.ichraDecisionToolPath],
])
